export default __webpack_public_path__ + "static/media/unavailable.f65c12ca.svg";